import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import * as links from 'documents-lib/js/lib/links';
import { trackInteraction } from 'documents-lib/js/tracking/tracker';
import { CLICK_PREVIEW_SUMMARY } from 'documents-lib/js/tracking/actions';
import { jsx as _jsx } from "react/jsx-runtime";
const PreviewHoverButtons = ({
  deckId
}) => /*#__PURE__*/_jsx(Button, {
  marginInlineEnd: "300",
  href: links.getPreviewURL(deckId),
  size: "extra-small",
  target: "_blank",
  use: "tertiary-light",
  external: true,
  onClick: () => trackInteraction(CLICK_PREVIEW_SUMMARY),
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "table.hoverButtons.preview"
  })
}, "preview");
export default PreviewHoverButtons;